export const environment = {
    production: true,
    identityUrl: 'https://identity-v2-staging.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://admin-tools-staging.nside.io',
    apiBaseUrl: 'https://v3-api-staging.nside.io',
    fleetApiBaseUrl: 'https://fleet-api-staging.nside.io',
    nSidePlatformUrl: 'https://staging.nside.io',
    mapsApiKey: 'AIzaSyDmuj0CHvnl2bLp5edx_F40He5ocej5-zk'
};
